"use client";

import { useBreakPoints } from "@/lib/useBreakPoints";
import { ArrowDownwardOutlined, Circle, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Button, List, ListItem, ListItemIcon, ListItemText, Popover, Typography } from "@mui/material";
import React, { useEffect, useMemo } from "react";

type Props = {
  features: string[];
};
export default function ProductFeaturesView({ features }: Props) {
  const { smAndDown } = useBreakPoints();
  const length = 3;

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  // useEffect(() => {
  //   if (!smAndDown) {
  //     if (open) {
  //       handleClose();
  //     }
  //   }
  // }, [smAndDown]);
  const id = open ? "simple-popover" : undefined;
  const list = useMemo(() => {
    if (smAndDown && open) {
      return features;
    }
    return features.filter((s, i) => i < length);
  }, [smAndDown, open]);

  return (
    <>
      <List dense={true}>
        {list.map((str, index) => {
          return (
            <ListItem key={index} sx={{ display: "flex", alignItems: "center", py: 0, pl: 0, gap: 0.5 }}>
              <Circle color="secondary" sx={{ fontSize: 9 }} />
              <ListItemText primary={<Typography variant="body2">{str}</Typography>} />
            </ListItem>
          );
        })}
      </List>
      {features.length > length && (
        <Box sx={{}}>
          <Button
            aria-describedby={id}
            variant="text"
            size={"small"}
            onClick={(e) => {
              if (open) {
                handleClose();
              } else {
                handleClick(e);
              }
            }}
            endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          >
            {open ? "نمایش کمتر" : "ویژگی های بیشتر"}
          </Button>
            <Popover
              slotProps={{
                paper: {
                  sx: {
                    boxShadow: `3px 6px 24px -6px #A1A1A129,-3px 0px 24px -6px #A1A1A11F`,
                    borderRadius: 3,
                    // minWidth: {
                    //   xs: hasItems ? "200px" : "300px",
                    //   md: hasItems ? "200px" : "300px",
                    // },
                    // maxWidth: {
                    //   xs: hasItems ? "330px" : "300px",
                    //   md: hasItems ? "330px" : "300px",
                    // },
                  },
                },
              }}
              id={id}
              open={open && !smAndDown}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
            >
              <List dense={true}>
                {features.map((str, index) => {
                  return (
                    <ListItem key={index} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Circle color="secondary" sx={{ fontSize: 9 }} />
                      <ListItemText primary={<Typography variant="body2">{str}</Typography>} />
                    </ListItem>
                  );
                })}
              </List>
            </Popover>
        </Box>
      )}
    </>
  );
}
